// import React, { useRef, useState, useLayoutEffect } from "react";

// /* ===== IMPORT REPORT COMPONENTS ===== */
// import AepsHistory from "../components/RetailerDasboard/AePS/AepsHistory";
// import DmtReports from "../components/RetailerDasboard/DMT/DmtReports";
// import Rechargereports from "../components/RetailerDasboard/RechargeandBills/Rechargereports";
// import PayoutReports from "../components/RetailerDasboard/Reports/PayoutReports";
// import BillPaymentReports from "../components/RetailerDasboard/RechargeandBills/BillPaymentReports";
// import CcbpReports from "../components/RetailerDasboard/Ccbp/CcbpReports";
// import PPITransaction from "../components/RetailerDasboard/PPI/PPITransaction";
// import PaymentReports from "../components/RetailerDasboard/PaymentGateway/PaymentReports";
// import CmsHistoryReports from "../components/RetailerDasboard/CMS/CmsHistoryReports";
// import InsuranceHistory from "../components/RetailerDasboard/RechargeandBills/InsuranceHistory";
// import GasHistory from "../components/RetailerDasboard/RechargeandBills/GasHistory";
// import EbillHistory from "../components/RetailerDasboard/RechargeandBills/EbillHistory";
// import BbpsOnlineHistory1 from "../components/RetailerDasboard/BBPSonline/BbpsOnlineHistory1";
// import FinkedaHistory from "../components/RetailerDasboard/PaymentGateway/FinkedaHistory";

// /* ===== HARD CODED TOP BUTTONS ===== */
// const TOP_BUTTONS = [
//   { label: "AEPS", value: "aepshistory" },
//   { label: "AEPS Settlement", value: "payoutReports" },
//   { label: "Mobile Recharge", value: "rechargetxnhistory" },
//   { label: "BBPS", value: "billpayhistory" },
//   { label: "BBPS Online", value: "bbpsonlinehistory" },
//   { label: "DMT", value: "dmttxnhistory" },
//   { label: "CCBP", value: "ccbptxnhistory" },
//   { label: "PPI", value: "ppitransactions" },
//   { label: "PG", value: "pgtxnhistory" },
//   { label: "PG BANK", value: "pgtxnbankhistory" },
//   { label: "CMS", value: "cmstxnhistory" },
//   { label: "INS", value: "insurancehistory" },
//   { label: "GAS", value: "gashistory" },
//   { label: "E-BILL", value: "electricity" },
// ];

// const TransactionHistory = () => {
//   const [activeReport, setActiveReport] = useState(null);
//   const reportRef = useRef(null);

//   /* ✅ SCROLL AFTER DOM PAINT — NO FLICKER */
//   useLayoutEffect(() => {
//     if (activeReport && reportRef.current) {
//       reportRef.current.scrollIntoView({
//         behavior: "smooth",
//         block: "start",
//       });
//     }
//   }, [activeReport]);

//   return (
//     <div className="space-y-10">

//       {/* ===== PAGE HEADER ===== */}
//       <div>
//         <h1 className="text-2xl font-semibold text-slate-900">
//           Transaction History
//         </h1>
//         <p className="text-sm text-slate-500 mt-1">
//           Select a service to view transaction reports below
//         </p>
//       </div>

//       {/* ===== TOP BUTTON BAR ===== */}
//       <div className="flex flex-wrap gap-4">
//         {TOP_BUTTONS.map((btn) => (
//           <button
//             key={btn.value}
//             onClick={() => setActiveReport(btn.value)}
//             className={`
//               px-6 py-2.5 rounded-full text-sm font-semibold
//               transition-all duration-300
//               ${
//                 activeReport === btn.value
//                   ? "bg-[#0A2A4F] text-white shadow-lg scale-105"
//                   : "bg-white text-[#0A2A4F] border border-slate-300 hover:bg-slate-100"
//               }
//             `}
//           >
//             {btn.label}
//           </button>
//         ))}
//       </div>

//       {/* ===== REPORT SECTION ===== */}
//       <div
//         ref={reportRef}
//         className="pt-6 scroll-mt-24" // ✅ prevents header overlap
//       >
//         {activeReport === "aepshistory" && <AepsHistory />}
//         {activeReport === "payoutReports" && <PayoutReports />}
//         {activeReport === "rechargetxnhistory" && <Rechargereports />}
//         {activeReport === "billpayhistory" && <BillPaymentReports />}
//         {activeReport === "bbpsonlinehistory" && <BbpsOnlineHistory1 />}
//         {activeReport === "dmttxnhistory" && <DmtReports />}
//         {activeReport === "ccbptxnhistory" && <CcbpReports />}
//         {activeReport === "ppitransactions" && <PPITransaction />}
//         {activeReport === "pgtxnhistory" && <PaymentReports />}
//         {activeReport === "cmstxnhistory" && <CmsHistoryReports />}
//         {activeReport === "insurancehistory" && <InsuranceHistory />}
//         {activeReport === "gashistory" && <GasHistory />}
//         {activeReport === "electricity" && <EbillHistory />}
//         {activeReport === "pgtxnbankhistory" && <FinkedaHistory />}

//         {!activeReport && (
//           <div className="mt-12 text-center text-slate-400 text-sm">
//             👆 Please select a service above to view transactions
//           </div>
//         )}
//       </div>
//     </div>
//   );
// };

// export default TransactionHistory;

// new ui 

// import React, { useRef, useState, useLayoutEffect } from "react";

// /* ===== IMPORT REPORT COMPONENTS ===== */
// import AepsHistory from "../components/RetailerDasboard/AePS/AepsHistory";
// import DmtReports from "../components/RetailerDasboard/DMT/DmtReports";
// import Rechargereports from "../components/RetailerDasboard/RechargeandBills/Rechargereports";
// import PayoutReports from "../components/RetailerDasboard/Reports/PayoutReports";
// import BillPaymentReports from "../components/RetailerDasboard/RechargeandBills/BillPaymentReports";
// import CcbpReports from "../components/RetailerDasboard/Ccbp/CcbpReports";
// import PPITransaction from "../components/RetailerDasboard/PPI/PPITransaction";
// import PaymentReports from "../components/RetailerDasboard/PaymentGateway/PaymentReports";
// import CmsHistoryReports from "../components/RetailerDasboard/CMS/CmsHistoryReports";
// import InsuranceHistory from "../components/RetailerDasboard/RechargeandBills/InsuranceHistory";
// import GasHistory from "../components/RetailerDasboard/RechargeandBills/GasHistory";
// import EbillHistory from "../components/RetailerDasboard/RechargeandBills/EbillHistory";
// import BbpsOnlineHistory1 from "../components/RetailerDasboard/BBPSonline/BbpsOnlineHistory1";
// import FinkedaHistory from "../components/RetailerDasboard/PaymentGateway/FinkedaHistory";

// import {
//   History,
//   Layers,
//   ArrowRight,
//   ShieldCheck,
//   CheckCircle2,
//   Sparkles,
//   MousePointerClick
// } from "lucide-react";

// /* ===== HARD CODED TOP BUTTONS ===== */
// const TOP_BUTTONS = [
//   { label: "AEPS", value: "aepshistory" },
//   { label: "AEPS Settlement", value: "payoutReports" },
//   { label: "Mobile Recharge", value: "rechargetxnhistory" },
//   { label: "BBPS", value: "billpayhistory" },
//   { label: "BBPS Online", value: "bbpsonlinehistory" },
//   { label: "DMT", value: "dmttxnhistory" },
//   { label: "CCBP", value: "ccbptxnhistory" },
//   { label: "PPI", value: "ppitransactions" },
//   { label: "PG", value: "pgtxnhistory" },
//   { label: "PG BANK", value: "pgtxnbankhistory" },
//   { label: "CMS", value: "cmstxnhistory" },
//   { label: "INS", value: "insurancehistory" },
//   { label: "GAS", value: "gashistory" },
//   { label: "E-BILL", value: "electricity" },
// ];

// const TransactionHistory = () => {
//   const [activeReport, setActiveReport] = useState(null);
//   const reportRef = useRef(null);

//   /* ✅ SCROLL AFTER DOM PAINT — NO FLICKER */
//   useLayoutEffect(() => {
//     if (activeReport && reportRef.current) {
//       reportRef.current.scrollIntoView({
//         behavior: "smooth",
//         block: "start",
//       });
//     }
//   }, [activeReport]);

//   const activeReportObj = TOP_BUTTONS.find((b) => b.value === activeReport);

//   return (
//     <div className="min-h-screen bg-[#F8FAFC] p-4 sm:p-6 lg:p-8 space-y-6">
      
//       {/* ================= PAGE HEADER ================= */}
//       <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4">
//         <div>
//           <div className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full text-xs font-semibold bg-blue-50 text-blue-700 border border-blue-100 mb-2">
//             <History className="w-3.5 h-3.5" />
//             Service Reports & Statements
//           </div>
//           <h1 className="text-2xl sm:text-3xl font-extrabold text-slate-800 tracking-tight">
//             Transaction History
//           </h1>
//           <p className="text-xs sm:text-sm text-slate-500 font-medium mt-0.5">
//             Select a service tab to inspect detailed logs, gateway callbacks, and receipts
//           </p>
//         </div>

//         {activeReport && (
//           <div className="flex items-center gap-2 self-start sm:self-auto bg-white px-3.5 py-1.5 rounded-2xl border border-slate-200/80 shadow-2xs">
//             <span className="w-2 h-2 rounded-full bg-emerald-500 animate-pulse"></span>
//             <span className="text-xs font-bold text-slate-700">
//               Active: {activeReportObj?.label}
//             </span>
//           </div>
//         )}
//       </div>

//       {/* ================= MODERN SERVICE BUTTONS CONTAINER ================= */}
//       <div className="bg-white rounded-3xl p-4 sm:p-5 border border-slate-200/80 shadow-xs space-y-3">
//         <div className="flex items-center justify-between px-1">
//           <span className="text-[11px] font-bold uppercase tracking-wider text-slate-400">
//             Available Service Portals
//           </span>
//           <span className="text-[11px] font-semibold text-slate-400">
//             {TOP_BUTTONS.length} Categories
//           </span>
//         </div>

//         {/* Scrollable / Wrapping Tabs */}
//         <div className="flex flex-wrap gap-2.5">
//           {TOP_BUTTONS.map((btn) => {
//             const isActive = activeReport === btn.value;

//             return (
//               <button
//                 key={btn.value}
//                 onClick={() => setActiveReport(btn.value)}
//                 className={`
//                   px-4 py-2.5 rounded-2xl text-xs font-bold transition-all duration-200 cursor-pointer select-none active:scale-95 flex items-center gap-1.5
//                   ${
//                     isActive
//                       ? "bg-slate-900 text-white shadow-md shadow-slate-900/15 border border-slate-900"
//                       : "bg-slate-50 hover:bg-slate-100/90 text-slate-600 border border-slate-200/70"
//                   }
//                 `}
//               >
//                 {isActive && <CheckCircle2 className="w-3.5 h-3.5 text-amber-400" />}
//                 <span>{btn.label}</span>
//               </button>
//             );
//           })}
//         </div>
//       </div>

//       {/* ================= REPORT SECTION ================= */}
//       <div
//         ref={reportRef}
//         className="scroll-mt-24 transition-all duration-300"
//       >
//         {activeReport ? (
//           <div className="bg-white rounded-3xl border border-slate-200/80 shadow-xs p-4 sm:p-6 animate-in fade-in duration-200">
//             {activeReport === "aepshistory" && <AepsHistory />}
//             {activeReport === "payoutReports" && <PayoutReports />}
//             {activeReport === "rechargetxnhistory" && <Rechargereports />}
//             {activeReport === "billpayhistory" && <BillPaymentReports />}
//             {activeReport === "bbpsonlinehistory" && <BbpsOnlineHistory1 />}
//             {activeReport === "dmttxnhistory" && <DmtReports />}
//             {activeReport === "ccbptxnhistory" && <CcbpReports />}
//             {activeReport === "ppitransactions" && <PPITransaction />}
//             {activeReport === "pgtxnhistory" && <PaymentReports />}
//             {activeReport === "cmstxnhistory" && <CmsHistoryReports />}
//             {activeReport === "insurancehistory" && <InsuranceHistory />}
//             {activeReport === "gashistory" && <GasHistory />}
//             {activeReport === "electricity" && <EbillHistory />}
//             {activeReport === "pgtxnbankhistory" && <FinkedaHistory />}
//           </div>
//         ) : (
//           /* Empty Selection State */
//           <div className="bg-white rounded-3xl border border-dashed border-slate-200 p-12 text-center flex flex-col items-center justify-center gap-3">
//             <div className="w-12 h-12 rounded-2xl bg-blue-50 text-blue-600 flex items-center justify-center">
//               <MousePointerClick className="w-6 h-6 animate-bounce" />
//             </div>
//             <div className="space-y-1">
//               <h3 className="text-sm font-bold text-slate-800">
//                 No Service Report Selected
//               </h3>
//               <p className="text-xs text-slate-400 max-w-sm">
//                 Choose any service category from the pills above to view its statement, filter dates, and export transaction data.
//               </p>
//             </div>
//           </div>
//         )}
//       </div>

//     </div>
//   );
// };

// export default TransactionHistory;


// new ui 2 


// import React, { useState } from "react";
// import {
//   History,
//   Building2,
//   Landmark,
//   Smartphone,
//   Receipt,
//   Layers,
//   ArrowRightLeft,
//   CreditCard,
//   WalletCards,
//   Briefcase,
//   ShieldCheck,
//   Flame,
//   Zap,
//   ExternalLink,
//   Search,
//   ChevronRight,
//   ShieldAlert
// } from "lucide-react";

// /* ===== 14 SERVICE CONFIGURATION WITH ROUTES & METADATA ===== */
// const SERVICES = [
//   {
//     label: "AEPS History",
//     desc: "Cash withdrawal, mini statements, and balance inquiries",
//     route: "/aeps-history",
//     icon: Building2,
//     badge: "Banking",
//     color: "from-blue-600 to-indigo-700",
//     lightBg: "bg-blue-50 text-blue-700 border-blue-100",
//   },
//   {
//     label: "AEPS Settlement",
//     desc: "Direct IMPS transfers",
//     route: "/Settlement-reports",
//     icon: Landmark,
//     badge: "Settlement",
//     color: "from-emerald-600 to-teal-700",
//     lightBg: "bg-emerald-50 text-emerald-700 border-emerald-100",
//   },
//   {
//     label: "Mobile Recharge",
//     desc: "Prepaid, postpaid mobile, and DTH transaction histories",
//     route: "/recharge-reports",
//     icon: Smartphone,
//     badge: "Utility",
//     color: "from-sky-500 to-blue-600",
//     lightBg: "bg-sky-50 text-sky-700 border-sky-100",
//   },
//   {
//     label: "BBPS Offline",
//     desc: "Standard bill payment receipts and provider logs",
//     route: "/bill-payment-reports",
//     icon: Receipt,
//     badge: "BBPS",
//     color: "from-violet-600 to-purple-700",
//     lightBg: "bg-violet-50 text-violet-700 border-violet-100",
//   },
//   {
//     label: "BBPS Online",
//     desc: "Real-time switch status, disputes, and complaint tracking",
//     route: "/bbps-online-history",
//     icon: Layers,
//     badge: "Live Switch",
//     color: "from-indigo-600 to-blue-800",
//     lightBg: "bg-indigo-50 text-indigo-700 border-indigo-100",
//   },
//   {
//     label: "DMT History",
//     desc: "Domestic money transfers, remitter to beneficiary logs",
//     route: "/dmt-reports",
//     icon: ArrowRightLeft,
//     badge: "Remittance",
//     color: "from-cyan-600 to-blue-700",
//     lightBg: "bg-cyan-50 text-cyan-700 border-cyan-100",
//   },
//   {
//     label: "Credit Card Bill (CCBP)",
//     desc: "Credit card bill payments, confirmations, and operator receipts",
//     route: "/ccbp-reports",
//     icon: CreditCard,
//     badge: "Cards",
//     color: "from-amber-600 to-orange-700",
//     lightBg: "bg-amber-50 text-amber-800 border-amber-200",
//   },
//   {
//     label: "PPI Transactions",
//     desc: "Prepaid payment instrument logs and wallet card transfer audits",
//     route: "/ppi-transactions",
//     icon: WalletCards,
//     badge: "Wallet",
//     color: "from-teal-600 to-emerald-700",
//     lightBg: "bg-teal-50 text-teal-700 border-teal-100",
//   },
//   {
//     label: "Payment Gateway (PG)",
//     desc: "Online collection gateway logs and customer checkout history",
//     route: "/payment-reports",
//     icon: CreditCard,
//     badge: "Gateway",
//     color: "from-purple-600 to-indigo-700",
//     lightBg: "bg-purple-50 text-purple-700 border-purple-100",
//   },
//   {
//     label: "PG Bank (Finkeda)",
//     desc: "Bank-level card network processing and checkout records",
//     route: "/finkeda-history",
//     icon: Landmark,
//     badge: "Banking PG",
//     color: "from-slate-700 to-slate-900",
//     lightBg: "bg-slate-100 text-slate-700 border-slate-200",
//   },
//   {
//     label: "CMS History",
//     desc: "Cash management deposits, acknowledgment numbers, and agency logs",
//     route: "/cms-reports",
//     icon: Briefcase,
//     badge: "Cash Agency",
//     color: "from-blue-700 to-slate-900",
//     lightBg: "bg-blue-50 text-blue-700 border-blue-100",
//   },
//   {
//     label: "Insurance History",
//     desc: "Premium payment logs, policy numbers, and digital insurer slips",
//     route: "/insurance-history",
//     icon: ShieldCheck,
//     badge: "Insurance",
//     color: "from-rose-600 to-pink-700",
//     lightBg: "bg-rose-50 text-rose-700 border-rose-100",
//   },
//   {
//     label: "Gas Utility",
//     desc: "LPG cylinder bookings and piped gas utility payment records",
//     route: "/gas-history",
//     icon: Flame,
//     badge: "Utility",
//     color: "from-orange-500 to-amber-600",
//     lightBg: "bg-orange-50 text-orange-700 border-orange-200",
//   },
//   {
//     label: "Electricity (E-Bill)",
//     desc: "Power distribution board bill payments and consumer audit slips",
//     route: "/ebill-history",
//     icon: Zap,
//     badge: "Power Board",
//     color: "from-yellow-600 to-amber-700",
//     lightBg: "bg-yellow-50 text-yellow-800 border-yellow-200",
//   },
// ];

// const TransactionHistory = () => {
//   const [searchQuery, setSearchQuery] = useState("");

//   const handleOpenInNewTab = (route) => {
//     window.open(route, "_blank", "noopener,noreferrer");
//   };

//   const filteredServices = SERVICES.filter(
//     (item) =>
//       item.label.toLowerCase().includes(searchQuery.toLowerCase()) ||
//       item.desc.toLowerCase().includes(searchQuery.toLowerCase()) ||
//       item.badge.toLowerCase().includes(searchQuery.toLowerCase())
//   );

//   return (
//     <div className="min-h-screen bg-[#F8FAFC] p-4 sm:p-6 lg:p-8 space-y-8 font-sans">
      
//       {/* ================= PAGE HEADER ================= */}
//       <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4">
//         <div>
//           <div className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full text-xs font-semibold bg-blue-50 text-blue-700 border border-blue-100 mb-2">
//             <History className="w-3.5 h-3.5" />
//             Centralized Statement Directory
//           </div>
//           <h1 className="text-2xl sm:text-3xl font-extrabold text-slate-800 tracking-tight">
//             Transaction History 
//           </h1>
//           <p className="text-xs sm:text-sm text-slate-500 font-medium mt-0.5">
//             Click on any service card below to launch its dedicated full-screen report in a new tab
//           </p>
//         </div>

//         {/* Search Input Filter */}
//         <div className="relative w-full sm:w-72">
//           <Search className="w-4 h-4 absolute left-3.5 top-1/2 -translate-y-1/2 text-slate-400" />
//           <input
//             type="text"
//             placeholder="Search service..."
//             value={searchQuery}
//             onChange={(e) => setSearchQuery(e.target.value)}
//             className="w-full pl-10 pr-4 py-2.5 bg-white border border-slate-200/80 focus:border-blue-500 focus:ring-2 focus:ring-blue-500/10 rounded-2xl text-xs font-semibold text-slate-700 placeholder-slate-400 outline-hidden transition shadow-2xs"
//           />
//         </div>
//       </div>

//       {/* ================= 14 SERVICES GRID CARDS ================= */}
//       <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4 sm:gap-5">
//         {filteredServices.map((service, idx) => {
//           const IconComponent = service.icon;

//           return (
//             <div
//               key={idx}
//               onClick={() => handleOpenInNewTab(service.route)}
//               className="group relative bg-white rounded-3xl p-5 sm:p-6 border border-slate-200/80 shadow-xs hover:shadow-xl hover:border-blue-500/30 hover:-translate-y-1 transition-all duration-200 cursor-pointer flex flex-col justify-between"
//             >
//               <div className="space-y-4">
//                 {/* Card Top Row: Icon + Badge + New Tab Arrow */}
//                 <div className="flex items-center justify-between">
//                   <div className={`p-3 rounded-2xl bg-gradient-to-br ${service.color} text-white shadow-md shadow-slate-900/10 transition-transform group-hover:scale-105`}>
//                     <IconComponent className="w-5 h-5" />
//                   </div>
                  
//                   <div className="flex items-center gap-2">
//                     <span className={`text-[10px] font-bold uppercase tracking-wider px-2.5 py-1 rounded-full border ${service.lightBg}`}>
//                       {service.badge}
//                     </span>
//                     <div className="p-1.5 rounded-xl bg-slate-50 text-slate-400 group-hover:bg-blue-50 group-hover:text-blue-600 transition">
//                       <ExternalLink className="w-3.5 h-3.5" />
//                     </div>
//                   </div>
//                 </div>

//                 {/* Card Info */}
//                 <div>
//                   <h3 className="text-base font-bold text-slate-800 group-hover:text-blue-600 transition">
//                     {service.label}
//                   </h3>
//                   <p className="text-xs text-slate-500 font-medium leading-relaxed mt-1 line-clamp-2">
//                     {service.desc}
//                   </p>
//                 </div>
//               </div>

//               {/* Bottom Action Hint */}
//               <div className="pt-4 mt-4 border-t border-slate-100 flex items-center justify-between text-xs font-bold text-slate-400 group-hover:text-blue-600 transition">
//                 <span>Launch Report</span>
//                 <ChevronRight className="w-4 h-4 transform group-hover:translate-x-1 transition" />
//               </div>
//             </div>
//           );
//         })}
//       </div>

//       {/* No Results Found */}
//       {filteredServices.length === 0 && (
//         <div className="bg-white rounded-3xl border border-dashed border-slate-200 p-12 text-center flex flex-col items-center justify-center gap-3">
//           <div className="w-12 h-12 rounded-2xl bg-slate-50 text-slate-400 flex items-center justify-center">
//             <Search className="w-6 h-6" />
//           </div>
//           <p className="text-sm font-bold text-slate-700">
//             No matching service portal found
//           </p>
//           <p className="text-xs text-slate-400">
//             Check your spelling or clear the search query.
//           </p>
//         </div>
//       )}

//     </div>
//   );
// };

// export default TransactionHistory;


import React, { useRef, useState, useLayoutEffect } from "react";
import { useSelector } from "react-redux";
import {
  History,
  Building2,
  Landmark,
  Smartphone,
  Receipt,
  Layers,
  ArrowRightLeft,
  CreditCard,
  WalletCards,
  Briefcase,
  ShieldCheck,
  Flame,
  Zap,
  Search,
  ChevronRight,
  ArrowLeft,
  CheckCircle2,
  Flag
} from "lucide-react";

/* ===== IMPORT REPORT COMPONENTS ===== */
import AepsHistory from "../components/RetailerDasboard/AePS/AepsHistory";
import DmtReports from "../components/RetailerDasboard/DMT/DmtReports";
import Rechargereports from "../components/RetailerDasboard/RechargeandBills/Rechargereports";
import PayoutReports from "../components/RetailerDasboard/Reports/PayoutReports";
import BillPaymentReports from "../components/RetailerDasboard/RechargeandBills/BillPaymentReports";
import CcbpReports from "../components/RetailerDasboard/Ccbp/CcbpReports";
import PPITransaction from "../components/RetailerDasboard/NewPPI/PPIHistory";
import PaymentReports from "../components/RetailerDasboard/PaymentGateway/PaymentReports";
import CmsHistoryReports from "../components/RetailerDasboard/CMS/CmsHistoryReports";
import InsuranceHistory from "../components/RetailerDasboard/RechargeandBills/InsuranceHistory";
import GasHistory from "../components/RetailerDasboard/RechargeandBills/GasHistory";
import EbillHistory from "../components/RetailerDasboard/RechargeandBills/EbillHistory";
import BbpsOnlineHistory1 from "../components/RetailerDasboard/BBPSonline/BbpsOnlineHistory1";
import IndoNepalReports from "../components/RetailerDasboard/IndoNepal/IndoNepalReports";
import FinkedaHistory from "../components/RetailerDasboard/PaymentGateway/FinkedaHistory";

/* ===== 14 SERVICE CONFIGURATION MAPPED TO VALUES ===== */
const SERVICES = [
  {
    label: "AEPS History",
    desc: "Cash withdrawal, mini statements, and balance inquiries",
    value: "aepshistory",
    icon: Building2,
    badge: "Banking",
    color: "from-blue-600 to-indigo-700",
    lightBg: "bg-blue-50 text-blue-700 border-blue-100",
  },
  {
    label: "AEPS Settlement",
    desc: "Direct IMPS transfers",
    value: "payoutReports",
    icon: Landmark,
    badge: "Settlement",
    color: "from-emerald-600 to-teal-700",
    lightBg: "bg-emerald-50 text-emerald-700 border-emerald-100",
  },
  {
    label: "Mobile Recharge",
    desc: "Prepaid, postpaid mobile, and DTH transaction histories",
    value: "rechargetxnhistory",
    icon: Smartphone,
    badge: "Utility",
    color: "from-sky-500 to-blue-600",
    lightBg: "bg-sky-50 text-sky-700 border-sky-100",
  },
  {
    label: "BBPS Offline",
    desc: "Standard bill payment receipts and provider logs",
    value: "billpayhistory",
    icon: Receipt,
    badge: "BBPS",
    color: "from-violet-600 to-purple-700",
    lightBg: "bg-violet-50 text-violet-700 border-violet-100",
  },
  {
    label: "BBPS Online",
    desc: "Real-time switch status, disputes, and complaint tracking",
    value: "bbpsonlinehistory",
    icon: Layers,
    badge: "Live Switch",
    color: "from-indigo-600 to-blue-800",
    lightBg: "bg-indigo-50 text-indigo-700 border-indigo-100",
  },
  {
    label: "DMT History",
    desc: "Domestic money transfers, remitter to beneficiary logs",
    value: "dmttxnhistory",
    icon: ArrowRightLeft,
    badge: "Remittance",
    color: "from-cyan-600 to-blue-700",
    lightBg: "bg-cyan-50 text-cyan-700 border-cyan-100",
  },
  {
    label: "Credit Card Bill (CCBP)",
    desc: "Credit card bill payments, confirmations, and operator receipts",
    value: "ccbptxnhistory",
    icon: CreditCard,
    badge: "Cards",
    color: "from-amber-600 to-orange-700",
    lightBg: "bg-amber-50 text-amber-800 border-amber-200",
  },
  {
    label: "PPI Transactions",
    desc: "Prepaid payment instrument logs and wallet card transfer audits",
    value: "ppitransactions",
    icon: WalletCards,
    badge: "Wallet",
    color: "from-teal-600 to-emerald-700",
    lightBg: "bg-teal-50 text-teal-700 border-teal-100",
  },
  {
    label: "Payment Gateway (PG)",
    desc: "Online collection gateway logs and customer checkout history",
    value: "pgtxnhistory",
    icon: CreditCard,
    badge: "Gateway",
    color: "from-purple-600 to-indigo-700",
    lightBg: "bg-purple-50 text-purple-700 border-purple-100",
  },
  {
    label: "PG Bank (Finkeda)",
    desc: "Bank-level card network processing and checkout records",
    value: "pgtxnbankhistory",
    icon: Landmark,
    badge: "Banking PG",
    color: "from-slate-700 to-slate-900",
    lightBg: "bg-slate-100 text-slate-700 border-slate-200",
  },
  {
    label: "CMS History",
    desc: "Cash management deposits, acknowledgment numbers, and agency logs",
    value: "cmstxnhistory",
    icon: Briefcase,
    badge: "Cash Agency",
    color: "from-blue-700 to-slate-900",
    lightBg: "bg-blue-50 text-blue-700 border-blue-100",
  },
  {
    label: "Insurance History",
    desc: "Premium payment logs, policy numbers, and digital insurer slips",
    value: "insurancehistory",
    icon: ShieldCheck,
    badge: "Insurance",
    color: "from-rose-600 to-pink-700",
    lightBg: "bg-rose-50 text-rose-700 border-rose-100",
  },
  {
    label: "Gas Utility",
    desc: "LPG cylinder bookings and piped gas utility payment records",
    value: "gashistory",
    icon: Flame,
    badge: "Utility",
    color: "from-orange-500 to-amber-600",
    lightBg: "bg-orange-50 text-orange-700 border-orange-200",
  },
  {
    label: "Electricity (E-Bill)",
    desc: "Power distribution board bill payments and consumer audit slips",
    value: "electricity",
    icon: Zap,
    badge: "Power Board",
    color: "from-yellow-600 to-amber-700",
    lightBg: "bg-yellow-50 text-yellow-800 border-yellow-200",
  },

   {
    label: "Indo Nepal",
    desc: "Indo Nepal Reports",
    value: "indonepalreports",
    icon: Flag,
    badge: "Indo Nepal",
    color: "from-red-600 to-amber-700",
    lightBg: "bg-yellow-50 text-yellow-800 border-yellow-200",
  },
];

const HIDDEN_FOR_SOU = new Set([
  "aepshistory",
  "payoutReports",
  "dmttxnhistory",
  "pgtxnbankhistory",
  "ppitransactions",
]);

const TransactionHistory = () => {
  const [activeReport, setActiveReport] = useState(null);
  const [searchQuery, setSearchQuery] = useState("");
  const reportRef = useRef(null);

  const username = useSelector((state) => state.auth?.employeeDetails?.username);
  const role = useSelector((state) => state.auth?.employeeDetails?.role);

  const hideRestricted = username === "sou4276_2330" && role === "MERCHANT";

  /* ✅ SMOOTH SCROLL AFTER SELECTING A REPORT */
  useLayoutEffect(() => {
    if (activeReport && reportRef.current) {
      reportRef.current.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    }
  }, [activeReport]);

  const activeServiceObj = SERVICES.find((b) => b.value === activeReport);

  const filteredServices = SERVICES.filter((item) => {
    if (hideRestricted && HIDDEN_FOR_SOU.has(item.value)) return false;
    return (
      item.label.toLowerCase().includes(searchQuery.toLowerCase()) ||
      item.desc.toLowerCase().includes(searchQuery.toLowerCase()) ||
      item.badge.toLowerCase().includes(searchQuery.toLowerCase())
    );
  });

  return (
    <div className="min-h-screen bg-[#F8FAFC] p-4 sm:p-6 lg:p-8 space-y-8 font-sans">
      
      {/* ================= PAGE HEADER ================= */}
      <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4">
        <div>
          <div className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full text-xs font-semibold bg-blue-50 text-blue-700 border border-blue-100 mb-2">
            <History className="w-3.5 h-3.5" />
            Centralized Statement Directory
          </div>
          <h1 className="text-2xl sm:text-3xl font-extrabold text-slate-800 tracking-tight">
            Transaction History 
          </h1>
          <p className="text-xs sm:text-sm text-slate-500 font-medium mt-0.5">
            Select a service card below to view its reports right on this page
          </p>
        </div>

        {/* Search Input Filter (Only shown when no report is active) */}
        {!activeReport && (
          <div className="relative w-full sm:w-72">
            <Search className="w-4 h-4 absolute left-3.5 top-1/2 -translate-y-1/2 text-slate-400" />
            <input
              type="text"
              placeholder="Search service portal..."
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              className="w-full pl-10 pr-4 py-2.5 bg-white border border-slate-200/80 focus:border-blue-500 focus:ring-2 focus:ring-blue-500/10 rounded-2xl text-xs font-semibold text-slate-700 placeholder-slate-400 outline-hidden transition shadow-2xs"
            />
          </div>
        )}
      </div>

      {/* ================= CARD GRID VIEW (Visible when no active report) ================= */}
      {!activeReport && (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4 sm:gap-5 animate-in fade-in duration-200">
          {filteredServices.map((service, idx) => {
            const IconComponent = service.icon;

            return (
              <div
                key={idx}
                onClick={() => setActiveReport(service.value)}
                className="group relative bg-white rounded-3xl p-5 sm:p-6 border border-slate-200/80 shadow-xs hover:shadow-xl hover:border-blue-500/30 hover:-translate-y-1 transition-all duration-200 cursor-pointer flex flex-col justify-between"
              >
                <div className="space-y-4">
                  <div className="flex items-center justify-between">
                    <div className={`p-3 rounded-2xl bg-gradient-to-br ${service.color} text-white shadow-md shadow-slate-900/10 transition-transform group-hover:scale-105`}>
                      <IconComponent className="w-5 h-5" />
                    </div>
                    
                    <span className={`text-[10px] font-bold uppercase tracking-wider px-2.5 py-1 rounded-full border ${service.lightBg}`}>
                      {service.badge}
                    </span>
                  </div>

                  <div>
                    <h3 className="text-base font-bold text-slate-800 group-hover:text-blue-600 transition">
                      {service.label}
                    </h3>
                    <p className="text-xs text-slate-500 font-medium leading-relaxed mt-1 line-clamp-2">
                      {service.desc}
                    </p>
                  </div>
                </div>

                <div className="pt-4 mt-4 border-t border-slate-100 flex items-center justify-between text-xs font-bold text-slate-400 group-hover:text-blue-600 transition">
                  <span>View Statement</span>
                  <ChevronRight className="w-4 h-4 transform group-hover:translate-x-1 transition" />
                </div>
              </div>
            );
          })}
        </div>
      )}

      {/* No Results Found */}
      {!activeReport && filteredServices.length === 0 && (
        <div className="bg-white rounded-3xl border border-dashed border-slate-200 p-12 text-center flex flex-col items-center justify-center gap-3">
          <div className="w-12 h-12 rounded-2xl bg-slate-50 text-slate-400 flex items-center justify-center">
            <Search className="w-6 h-6" />
          </div>
          <p className="text-sm font-bold text-slate-700">
            No matching service portal found
          </p>
        </div>
      )}

      {/* ================= ACTIVE REPORT CONTAINER (Rendered Inline) ================= */}
      <div ref={reportRef} className="scroll-mt-24 transition-all duration-300">
        {activeReport && (
          <div className="space-y-4 animate-in fade-in zoom-in-95 duration-200">
            
            {/* Back Button Bar */}
            <div className="flex items-center justify-between bg-white px-5 py-3.5 rounded-2xl border border-slate-200/80 shadow-xs">
              <button
                onClick={() => setActiveReport(null)}
                className="inline-flex items-center gap-2 px-3.5 py-2 rounded-xl bg-slate-100 hover:bg-slate-200 text-slate-700 text-xs font-bold transition active:scale-95 cursor-pointer"
              >
                <ArrowLeft className="w-4 h-4" />
                <span>Back </span>
              </button>

              <div className="flex items-center gap-2">
                <span className="w-2 h-2 rounded-full bg-emerald-500 animate-pulse"></span>
                <span className="text-xs font-bold text-slate-700">
                  Active Service: {activeServiceObj?.label}
                </span>
              </div>
            </div>

            {/* Selected Component Container */}
            <div className="bg-white rounded-3xl border border-slate-200/80 shadow-xs p-4 sm:p-6">
              {activeReport === "aepshistory" && <AepsHistory />}
              {activeReport === "payoutReports" && <PayoutReports />}
              {activeReport === "rechargetxnhistory" && <Rechargereports />}
              {activeReport === "billpayhistory" && <BillPaymentReports />}
              {activeReport === "bbpsonlinehistory" && <BbpsOnlineHistory1 />}
              {activeReport === "dmttxnhistory" && <DmtReports />}
              {activeReport === "ccbptxnhistory" && <CcbpReports />}
              {activeReport === "ppitransactions" && <PPITransaction />}
              {activeReport === "pgtxnhistory" && <PaymentReports />}
              {activeReport === "pgtxnbankhistory" && <FinkedaHistory />}
              {activeReport === "cmstxnhistory" && <CmsHistoryReports />}
              {activeReport === "insurancehistory" && <InsuranceHistory />}
              {activeReport === "gashistory" && <GasHistory />}
              {activeReport === "electricity" && <EbillHistory />}
              {activeReport === "indonepalreports" && <IndoNepalReports />}
            </div>

          </div>
        )}
      </div>

    </div>
  );
};

export default TransactionHistory;